export default __webpack_public_path__ + "static/media/angular.b5045666.jpg";